import { isPortalLinkPath, PORTAL_LINK_RFP_PATH } from 'rate-command-center/ui/PortalLinkRoute'

import { PORTAL_BASE_PATH } from '../../core/ui/PortalRoute'

export const PORTAL_RFP_PATH = `${PORTAL_BASE_PATH}/rfp`

export function getRfpBasePath(pathname: string): string {
  return isPortalLinkPath(pathname) ? PORTAL_LINK_RFP_PATH : PORTAL_RFP_PATH
}

// A logged-out carrier on an invite link has no RFP list to go back to.
export function getRfpListBackPath(pathname: string, isLoggedIn: boolean): string | undefined {
  return isLoggedIn || isPortalLinkPath(pathname) ? getRfpBasePath(pathname) : undefined
}
